/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_shorts_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I set a custom thumbnail for a Short?`)
};

const es_yt_shorts_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo poner una miniatura personalizada para un Short?`)
};

const de_yt_shorts_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich für einen Short ein eigenes Thumbnail festlegen?`)
};

const nl_yt_shorts_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik een aangepaste thumbnail instellen voor een Short?`)
};

const fr_yt_shorts_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je définir une miniature personnalisée pour un Short ?`)
};

const it_yt_shorts_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso impostare una miniatura personalizzata per uno Short?`)
};

const pt_br2_yt_shorts_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso definir uma thumbnail personalizada para um Short?`)
};

const pt_yt_shorts_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso definir uma miniatura personalizada para um Short?`)
};

const ja_yt_shorts_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shortにカスタムサムネイルを設定できますか？`)
};

const zh_yt_shorts_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以为 Short 设置自定义缩略图吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_shorts_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_shorts_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_shorts_faq4_q", locale)
	if (locale === "en") return en_yt_shorts_faq4_q(inputs)
	if (locale === "es") return es_yt_shorts_faq4_q(inputs)
	if (locale === "de") return de_yt_shorts_faq4_q(inputs)
	if (locale === "nl") return nl_yt_shorts_faq4_q(inputs)
	if (locale === "fr") return fr_yt_shorts_faq4_q(inputs)
	if (locale === "it") return it_yt_shorts_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_yt_shorts_faq4_q(inputs)
	if (locale === "pt") return pt_yt_shorts_faq4_q(inputs)
	if (locale === "ja") return ja_yt_shorts_faq4_q(inputs)
	return zh_yt_shorts_faq4_q(inputs)
};